/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SkeletonInputs */

const cs_enum_skeleton = /** @type {(inputs: Enum_SkeletonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skelet`)
};

const en_enum_skeleton = /** @type {(inputs: Enum_SkeletonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skeleton`)
};

/**
* | output |
* | --- |
* | "Skeleton" |
*
* @param {Enum_SkeletonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_skeleton = /** @type {((inputs?: Enum_SkeletonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SkeletonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_skeleton(inputs)
	return cs_enum_skeleton(inputs)
});